import type {IntlShape} from 'react-intl';
import {useIntl} from 'react-intl';
import {MicOff, RefreshCw, Wifi} from 'lucide-react';
import type {CallNetwork} from '../model/types';
import {groupSurfaceMessages as m} from '../group/groupMessages';
import {StatusNote} from './controls';

/** D-INCALL-02/S10–S12: reconnecting wins over a weak connection, and both win over muted. */
export const CallStateNotes = ({network, muted}: {network: CallNetwork; muted: boolean}) => {
    const intl = useIntl();
    if (network === 'reconnecting') {
        return <StatusNote tone="reconnecting" icon={<RefreshCw size={16} className="animate-spin" aria-hidden="true"/>}>{intl.formatMessage(m.noteReconnecting)}</StatusNote>;
    }
    return (
        <>
            {network === 'weak' && <StatusNote tone="weak" icon={<Wifi size={16} aria-hidden="true"/>}>{intl.formatMessage(m.noteWeak)}</StatusNote>}
            {muted && <StatusNote tone="muted" icon={<MicOff size={16} aria-hidden="true"/>}>{intl.formatMessage(m.noteMuted)}</StatusNote>}
        </>
    );
};

/** "Call with Sophia Mitchell, muted": the bubble region names the state the notes show. */
export const regionWithState = (intl: IntlShape, region: string, state: {network: CallNetwork; muted: boolean}): string => {
    const suffix = state.network === 'reconnecting'
        ? m.regionReconnecting
        : state.network === 'weak'
            ? m.regionWeak
            : state.muted
                ? m.regionMuted
                : undefined;
    return suffix ? intl.formatMessage(suffix, {region}) : region;
};
